import { useQuery } from "@tanstack/react-query"
import { NotificationTopicGet } from "../app/models/NotificationTopic"
import { digitalManagerApi } from "../services/api"

export function useNotificationTopics(retrieveAll = false, applicationId?: string) {
  const { data: notificationTopicsList = [], isLoading: isLoadingNotificationTopics } =
    useQuery({
      queryKey: ["notificationTopics", retrieveAll, applicationId],
      queryFn: async () => {
        const url = retrieveAll
          ? "/notificationTopics"
          : `/notificationTopics/applications/${applicationId}`

        const res = await digitalManagerApi.get<NotificationTopicGet[]>(url)
        return res.data
      },
      enabled: retrieveAll || !!applicationId,
    })

  return {
    notificationTopicsList,
    isLoadingNotificationTopics,
  }
}
